import { Injectable, Injector } from '@angular/core';
import { BaseResourceService } from './base-resource.service';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FieldsDecimals } from '../interfaces/schema-fields.model';

@Injectable({
  providedIn: 'root'
})
export class SchemaFieldsService extends BaseResourceService {

  constructor(
    protected override injector: Injector,
    private http: HttpClient
  ) {
    super('SchemaFields', injector, 'codeschema')
  }

  async getFieldsDecimals(): Promise<FieldsDecimals> {
    const data$ = this.http.get<FieldsDecimals>(`${environment.url}api/tgv/schemafields/decimals`);
    return await firstValueFrom(data$);
  }
}
